export default __webpack_public_path__ + "static/media/num-02.0ca836aa.svg";